module.exports = "<div class=\"b3-stats-cell__value\">{{ currentValue }}%</div>\n"